import { render, staticRenderFns } from "./FormSettings.vue?vue&type=template&id=24ab6d70&scoped=true"
import script from "./FormSettings.vue?vue&type=script&lang=js"
export * from "./FormSettings.vue?vue&type=script&lang=js"
import style0 from "./FormSettings.vue?vue&type=style&index=0&id=24ab6d70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ab6d70",
  null
  
)

export default component.exports